import Script from "next/script"

type OneTagScriptProps = {
  segmentId?: string
  segmentGroup?: string
  scriptId?: string
  accountId?: string
  netreferId?: string
}

export function OneTagScript({
  segmentId,
  segmentGroup,
  scriptId,
  accountId,
  netreferId,
}: Readonly<OneTagScriptProps>) {
  return (
    <Script
      src={generateScriptUrl(
        segmentGroup,
        segmentId,
        accountId,
        netreferId,
      ).toString()}
      referrerPolicy="no-referrer-when-downgrade"
      id={scriptId}
    />
  )
}

function generateScriptUrl(
  segmentGroup?: string,
  segmentId?: string,
  accountId?: string,
  netreferId?: string,
) {
  const scriptUrl = new URL("https://onetag-sys.com/audience-router/")
  scriptUrl.searchParams.set("tag", "script")
  if (segmentGroup != null) {
    scriptUrl.searchParams.set("segment_group", segmentGroup)
  }
  if (segmentId != null) {
    scriptUrl.searchParams.set("segment_id", segmentId)
  }
  if (accountId != null) {
    scriptUrl.searchParams.set("account_id", accountId)
  }
  if (netreferId != null) {
    scriptUrl.searchParams.set("netrefer_id", netreferId)
  }
  return scriptUrl
}
